export default __webpack_public_path__ + "static/media/errorIcon.35f16b36.png";